import { render, staticRenderFns } from "./ToolsRegistration.vue?vue&type=template&id=2a7ade65&scoped=true&"
import script from "./ToolsRegistration.vue?vue&type=script&lang=js&"
export * from "./ToolsRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ToolsRegistration.vue?vue&type=style&index=0&id=2a7ade65&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ade65",
  null
  
)

export default component.exports